<template>
  <div class="sign-up-advantages">
    <div class="title">
      {{ $t('SHOP.AUTH.HEADER.SIGN_UP_ADVANTAGES') }}
    </div>
    <div class="info">
      <SfIconDocument aria-hidden="true" />
      <div class="text">
        {{ $t('SHOP.AUTH.MESSAGE.SIGN_UP_ADVANTAGE_1') }}
      </div>
    </div>
    <div class="info">
      <SfIconClock aria-hidden="true" />
      <div class="text">
        {{ $t('SHOP.AUTH.MESSAGE.SIGN_UP_ADVANTAGE_2') }}
      </div>
    </div>
    <div class="info">
      <SfIconTruck aria-hidden="true" />
      <div class="text">
        {{ $t('SHOP.AUTH.MESSAGE.SIGN_UP_ADVANTAGE_3') }}
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @use "@storefront/styles/mixins/media";

  .sign-up-advantages {
    color: var(--secondary-color);
    font-size: 0.75rem;

    .title {
      font-weight: var(--font-weight-semi);
    }

    .info {
      display: flex;
      align-items: center;
      column-gap: 0.5rem;
      margin-top: 0.5rem;

      .text {
        padding: 0;
      }

      svg {
        font-size: 1.25rem;
      }
    }
  }

  @include media.query(lg) {
    .sign-up-advantages .info {
      column-gap: 0.375rem;

      svg {
        font-size: 1rem;
      }
    }
  }
</style>
<script lang="ts" setup>
</script>
